var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "text-2xl font-bold mb-6"
  }, [_vm._v("Role Management")]), _c('div', {
    staticClass: "flex justify-center w-3/5 items-center gap-2 text-primary-500"
  }, _vm._l(_vm.roleList, function (role, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-1 text-center border border-primary-500 border-b-0 py-2 rounded-t-lg block transition-all cursor-pointer",
      class: {
        'bg-primary-500 text-white font-medium': role.isActive
      },
      on: {
        "click": function ($event) {
          return _vm.selectTab(role);
        }
      }
    }, [_vm._v(" " + _vm._s(role.title) + " ")]);
  }), 0), _c('div', {
    staticClass: "border p-6 border-primary-500 rounded-b-md rounded-r-md shadow-lg"
  }, [_c('div', {
    staticClass: "flex gap-6 items-start justify-between"
  }, [_c('div', {
    staticClass: "flex gap-6 items-start"
  }, [_c('p', [_vm._v("Please select the role:")]), _c('div', {
    staticClass: "w-52"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.selectedGroupRole
    },
    model: {
      value: _vm.selectedRole,
      callback: function ($$v) {
        _vm.selectedRole = $$v;
      },
      expression: "selectedRole"
    }
  })], 1), _c('p', [_vm._v("Or")]), _c('div', [_c('Button', {
    attrs: {
      "buttonText": "Add New Role",
      "type": "secondary"
    },
    on: {
      "action": function ($event) {
        return _vm.toggleField();
      }
    }
  })], 1)]), _c('Button', {
    attrs: {
      "buttonText": "Save"
    }
  })], 1), _c('div', {
    staticClass: "text-center mt-10"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-10"
  }, [_vm._v("Permission Settings")]), _vm._l(_vm.permissionList, function (group, index) {
    return _c('div', {
      key: `group-${index}`,
      staticClass: "mb-10"
    }, [_c('div', {
      staticClass: "bg-neutral-600 text-white text-left text-base px-4 py-3 mb-6 rounded-md"
    }, [_vm._v(_vm._s(group.groupTitle))]), _c('div', {
      staticClass: "w-3/5 pl-6"
    }, [_c('table', {
      staticClass: "border-collapse w-full table-fixed text-left"
    }, [_vm._m(0, true), _c('tbody', _vm._l(group.list, function (item) {
      return _c('tr', {
        key: item.id
      }, [_c('td', {
        staticClass: "border py-2 px-4"
      }, [_vm._v(_vm._s(item.title))]), _c('td', {
        staticClass: "border py-2 px-4 text-center align-middle leading-0"
      }, [_c('label', {
        staticClass: "relative inline-block h-4 leading-0"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.permissionModel[item.id],
          expression: "permissionModel[item.id]"
        }],
        staticClass: "w-10 h-4 transition bg-gray-300 rounded-full shadow-inner outline-none appearance-none checked:bg-blue-500 disabled:bg-gray-100",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(_vm.permissionModel[item.id]) ? _vm._i(_vm.permissionModel[item.id], null) > -1 : _vm.permissionModel[item.id]
        },
        on: {
          "change": function ($event) {
            var $$a = _vm.permissionModel[item.id],
                $$el = $event.target,
                $$c = $$el.checked ? true : false;

            if (Array.isArray($$a)) {
              var $$v = null,
                  $$i = _vm._i($$a, $$v);

              if ($$el.checked) {
                $$i < 0 && _vm.$set(_vm.permissionModel, item.id, $$a.concat([$$v]));
              } else {
                $$i > -1 && _vm.$set(_vm.permissionModel, item.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.$set(_vm.permissionModel, item.id, $$c);
            }
          }
        }
      }), _c('span', {
        staticClass: "absolute top-0 left-0 w-4 h-4 transition-all transform scale-150 bg-system-gray rounded-full shadow-sm cursor-pointer"
      })])])]);
    }), 0)])])]);
  })], 2)]), _c('Modal', {
    attrs: {
      "show": _vm.visibleField
    },
    on: {
      "close": function ($event) {
        return _vm.closeModal();
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('p', {
    staticClass: "text-xl font-bold text-center"
  }, [_vm._v("Add New Role")])]), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "flex gap-4 mt-6 items-center justify-center"
  }, [_c('div', {
    staticClass: "w-3/5"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Role name"
    },
    model: {
      value: _vm.newRole,
      callback: function ($$v) {
        _vm.newRole = $$v;
      },
      expression: "newRole"
    }
  })], 1), _c('div', [_c('Button', {
    attrs: {
      "buttonText": "Add",
      "type": "primary"
    },
    on: {
      "action": function ($event) {
        return _vm.addRole();
      }
    }
  })], 1)])])], 2)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "border py-2 px-4 bg-system-gray text-center"
  }, [_vm._v("Permission Fuction")]), _c('td', {
    staticClass: "border py-2 px-4 bg-system-gray text-center"
  }, [_vm._v(" ")])])]);

}]

export { render, staticRenderFns }